import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=ccd6e4c4&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports